export const PERMISSIONS = {
    Admin: "caderno_LPMA.admin",
    Visitante: "caderno_LPMA.visitante",
    Requisitante: "caderno_LPMA.requisitante",
    // Legadas — ainda podem existir no JWT até re-login após migration
    RequisitanteRead: "caderno_LPMA.requisitante.read",
    RequisitanteWrite: "caderno_LPMA.requisitante.write",
}

export const isAdmin = (roles: string[]): boolean => {
    const isRole = roles.filter(role => role === PERMISSIONS.Admin);

    return isRole.length ? true : false;
}
export const isCheck = (roles: string[], isPerm: string): boolean => {
    const isRole = roles.filter(role => role === isPerm);
    return isRole.length ? true : false;
}
